export default __webpack_public_path__ + "static/media/no-product-image.332cd005.png";